import { render, staticRenderFns } from "./user-account.vue?vue&type=template&id=bbe70bc0&scoped=true&"
import script from "./user-account.vue?vue&type=script&lang=js&"
export * from "./user-account.vue?vue&type=script&lang=js&"
import style0 from "./user-account.vue?vue&type=style&index=0&id=bbe70bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe70bc0",
  null
  
)

export default component.exports